<ng-progress color="red" [thick]="true" [spinner]="false" [trickleSpeed]="500" [ease]="'easeInSine'" (started)="ngProgress.startedClass" (completed)="ngProgress.endedClass"></ng-progress>
<div id="azureReportingDashboard" class="subBlockContainer">
  <div class="subBlockContent">
    <child-header [title]="title" (closeEvent)="close()"></child-header>
    <div class="inner-subBlock-wrapper">
      <!-- <div class="page-title-wrapper">
        <div class="title blade-title">
          {{title}}
        </div>
        <i class="material-icons closebutton-pullfloat-right" (click)="close()">close</i>
      </div> -->

      <div id="basic-info-wrapper">
        <div style="margin-bottom: 20px;" class="row filter-wrapper">
          <div class="row filter-wrapper margin-l-x15 padding-b-x10">
            <!-- <div class="col searchInput-position">
              <div class="searchInputGroup">
                <div class="searchIcon">
                  <img src="../../images/new_ui/filter.png">
                </div>
                <input class="searchInput" type="text" placeholder="Filter" onfocus="this.placeholder=''"
                  onblur="this.placeholder='Filter'" [(ngModel)]="searchField" (ngModelChange)="onChange()">
              </div>
            </div> -->
            <div class="col col-large date-picker-margin">
              Date From:
              <div class="searchInputGroup">
                <div class="searchIcon" (click)="dateFrom.toggle()">
                  <img src="../../images/new_ui/date.png">
                </div>
                <input id="dateFrom" class="searchInput date-picker" type="text" [(ngModel)]="fromDate" (ngModelChange)="onFromDateChange()"
                  placeholder="Date" mame="datePicker" ngbDatepicker #dateFrom="ngbDatepicker"
                  (click)="dateFrom.toggle()">
              </div>
            </div>
            <div class="col col-large date-picker-margin">
              To:
              <div class="searchInputGroup">
                <div class="searchIcon" (click)="dateTo.toggle()">
                  <img src="../../images/new_ui/date.png">
                </div>
                <input id="dateTo" class="searchInput date-picker" type="text" [(ngModel)]="toDate" placeholder="Date" [minDate]="minToDate" [maxDate]="maxToDate"
                  mame="datePicker" ngbDatepicker #dateTo="ngbDatepicker" (click)="dateTo.toggle()">

              </div>
            </div>
            <div class="col col-small button-position">
              <button mat-button [class.collapse-btn]="true" (click)="downloadLogs();"><i class="basic-icon download-icon"></i>Download Excel</button>
              <!-- <button id="btnFilter" class="button button-red" style="width: 105px; border-radius: 30px;" (click)="downloadLogs();">Download Excel</button> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<router-outlet></router-outlet>